(function () {
    'use strict';

    angular
        .module('Lavpop-store.routes')
        .config(routes);

    /** @ngInject */
    function routes($stateProvider, PATHS) {
        $stateProvider
            .state('auth', {
                abstract: true,
                templateUrl: `${PATHS.PHYSICAL}/components/layout/authentication-layout.html`,
                onEnter: ($rootScope) => {
                    $rootScope.isOauth = true;
                    $rootScope.hideLoading = true;
                }
            })

            .state('auth.oauthcallback', {
                title: 'Autenticação',
                url: '/oauthcallback',
                templateUrl: `${PATHS.PHYSICAL}/components/oauthcallback/oauthcallback.html`,
                controller: 'OauthCallbackController',
                controllerAs: 'vm'
            })
    }
}());